// extracted by mini-css-extract-plugin
export default {"items_container":"ProductsVideos_items_container__+jwbq","item_wrapper":"ProductsVideos_item_wrapper__1swXA"};